module.exports = __webpack_public_path__ + "img/table-edit-icon.a144608a.svg";